import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';

import CookieConsentEditor from '../../components/CookieConsentEditor.jsx';

const cookieConsentEditor = document.getElementById('cookie-consent-editor');
if (cookieConsentEditor !== null && cookieConsentEditor !== undefined) {
  ReactDOM.render(<CookieConsentEditor />, cookieConsentEditor);
}